import reducer from "./reducer";
export { default as TypesOfPublicationFormats } from "./components/index";
export { default as typesOfPublicationFormatsReducerName } from "./constants";
export default reducer;
